import Footer from 'components/UI/footer/Footer';
import DashboardHeader from 'components/UI/layout/components/DashboardHeader';
import Sidebar from 'components/UI/layout/components/dashboardSidebar/Sidebar';
import EmergencyInfos from 'components/UI/layout/components/emergencyInfos/EmergencyInfos';
import { FC, ReactNode, memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'redux/store';

interface IDashboardLayout {
  children: ReactNode;
}

const Layout: FC<IDashboardLayout> = ({ children }) => {
  //state
  const { userProfile } = useSelector((state: RootState) => state.user);

  //hooks
  const { pathname } = useLocation();

  if (pathname.startsWith('/print/'))
    return (
      <div className=''>
        <DashboardHeader />
        <div className='flex'>
          <div className='relative w-full px-6 py-6 mx-auto max-w-7xl'>{children}</div>
        </div>
      </div>
    );

  return (
    <div className='h-full flex flex-col'>
      <DashboardHeader />
      <div className='flex flex-1'>
        {pathname.startsWith('/dashboard') && (
          <div className='sticky hidden h-full py-6 top-16 md:block print:hidden'>
            <Sidebar />
          </div>
        )}
        <div
          className={`w-full mx-auto px-6 pt-6 pb-20 ${
            !pathname.startsWith('/dashboard') ? ' bg-gradient-to-b dark:from-[#353535] dark:to-[#003020c5] from-[#d5e7e1c5] to-[#f7faf9c5] ' : 'max-w-7xl'
          }`}>
          {pathname.startsWith('/dashboard') && userProfile && <EmergencyInfos />}
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default memo(Layout);
